const newReceiver = {
    receiverName:"Nuevo Destinatario",
    phone:"",
    city:"",
    township:"",
    province:"",
    address:"",
    carnet:"",
    buildingNumber:"",
    distribution:"",
    middleStreets:"",
    principalStreet: ""
  }
export default newReceiver;